/** @jsx jsx */
import { jsx, Box, Flex, useColorMode } from "theme-ui"
import { useConfig, useCurrentDoc } from "docz"
import Menu from "react-feather/dist/icons/menu"

import * as styles from "./styles"
import { Logo } from "../Logo"

export const Header = props => {
  const { onOpen } = props
  const {
    repository,
    themeConfig: { showDarkModeSwitch, showMarkdownEditButton }
  } = useConfig()
  const { edit = true, ...doc } = useCurrentDoc()
  const [colorMode, setColorMode] = useColorMode()

  const toggleColorMode = () => {
    setColorMode(colorMode === "light" ? "dark" : "light")
  }

  return (
    <div sx={styles.wrapper} data-testid="header">
      <Box sx={styles.menuIcon}>
        <button sx={styles.menuButton} onClick={onOpen}>
          <Menu size={25} />
        </button>
      </Box>
      <div sx={styles.innerContainer}>
        <Logo />
      </div>
    </div>
  )
}
